/**
 * Ceiling on recorded action durations. Suspended background tabs produce multi-hour "actions"
 * (21,000 s `feed.navigate` maxima) that poison perceived-latency percentiles; anything past the
 * ceiling is a suspension artifact, not a measurement.
 */
export const ACTION_DURATION_CEILING_MS = 10 * 60 * 1000;

export type ClampedActionDuration = {
  /** End timestamp to record (epoch ms), moved back to the ceiling when clamped. */
  endTime: number;
  /** Duration to record (ms), never above {@link ACTION_DURATION_CEILING_MS}. */
  durationMs: number;
  /** True when the raw duration exceeded the ceiling — preserved on the span as `overflow=true`. */
  overflow: boolean;
};

/** Clamps an action's recorded duration at the ceiling while flagging the overflow. */
export function clampActionDuration(startTime: number, endTime: number): ClampedActionDuration {
  const durationMs = endTime - startTime;
  if (durationMs <= ACTION_DURATION_CEILING_MS) {
    return { endTime, durationMs, overflow: false };
  }
  return {
    endTime: startTime + ACTION_DURATION_CEILING_MS,
    durationMs: ACTION_DURATION_CEILING_MS,
    overflow: true,
  };
}
